import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { type ProductOfDayDataType } from '@/common/types/contract';
import { MainButton } from '@/components/ui/Button/Button';

import { ModalContext } from '../Modal/config';

interface ProductOfDayClaimButtonProps {
  product: ProductOfDayDataType;
  className?: string;
}

const ProductOfDayClaimButton: FC<ProductOfDayClaimButtonProps> = ({
  product,
  className,
}) => {
  const { t } = useTranslation();
  const { secondModal, closeModal, thirdModal } = useContext(ModalContext);

  const handleClose = (): void => {
    if (
      thirdModal.isOpen &&
      thirdModal.modalContent.renderKind === 'productOfDayModal'
    ) {
      thirdModal.closeModal();
    } else {
      closeModal();
    }
  };

  return (
    <MainButton
      text={product.chestBoxOpenedAt ? t('Ok') : t('Spin')}
      className={className}
      disabled={product.progress < product.countToReward}
      inactive={product.progress < product.countToReward}
      onClick={() => {
        if (product.chestBoxOpenedAt) {
          return handleClose();
        }
        secondModal.openModal({
          props: { productId: product.id },
          renderKind: 'productOfDaySpin',
        });
      }}
    />
  );
};

export default ProductOfDayClaimButton;
